import { memo } from "react";
import { formatCurrency, formatDecimal, useTranslate } from "helpers";
import { CalculationPriceTotalDetailCardProps } from "./types";

const MONTHLY_RENTAL = 2556.39;

const CalculationPriceTotalDetailCard: React.FC<
  CalculationPriceTotalDetailCardProps
> = (props) => {
  const { formValues } = props;

  const { t } = useTranslate();

  return (
    <>
      <div className="space-y-2.5">
        <div className="flex justify-between items-center text-sm">
          <span className="text-slate-500">
            {t("admin.calculation.price.total.annualcontractedmileage")}
          </span>
          <span className="font-semibold text-slate-900">
            {formatDecimal(String(formValues.rentKm))} km
          </span>
        </div>
        <div className="flex justify-between items-center text-sm">
          <span className="text-slate-500">
            {t("admin.calculation.price.total.durationofthelease")}
          </span>
          <span className="font-semibold text-slate-900">
            {formValues.rentMonths}
          </span>
        </div>
      </div>

      {/* Tamna traka — mjesečni najam (probija padding "Sažetak" sekcije) */}
      <div className="-mx-4 -mb-6 mt-6 px-5 py-4 bg-slate-900 flex items-center justify-between">
        <span className="text-sm font-medium text-slate-300">
          {t("admin.calculation.price.total.monthlycarrental")}
        </span>
        <span className="text-xl font-bold text-white">
          {formatCurrency.format(MONTHLY_RENTAL)}
        </span>
      </div>
    </>
  );
};
export default memo(CalculationPriceTotalDetailCard);
